import { FormProvider, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../index';
import { InputForm } from '../../../index';
import { FormFieldsResetPassword } from '../useResetPassword';

interface Props {
  loading?: boolean;
  onSubmit: ({ password, confirmPassword }: FormFieldsResetPassword) => unknown;
}

const ResetPasswordForm: React.FC<Props> = ({ loading, onSubmit }) => {
  const { t } = useTranslation('auth');
  const methods = useFormContext<FormFieldsResetPassword>();
  const { trigger, getValues } = methods;

  const handleSubmit = async () => {
    const noError = await trigger();
    if (noError) onSubmit(getValues());
  };

  return (
    <FormProvider {...methods}>
      <div className="w-full flex-col space-y-2">
        <div>
          <p className="text-sm text-gray-700 dark:text-gray-400">
            {t('resetPassword.insertNewPassword')}
          </p>
        </div>
        <div className="flex-col space-y-1">
          <InputForm
            name="password"
            label={t('resetPassword.form.password')}
            type="password"
            errorName="password"
          />
          <InputForm
            name="confirmPassword"
            label={t('resetPassword.form.confirmPassword')}
            type="password"
            errorName="confirmPassword"
          />
          <div>
            <Button
              className="w-full mt-2"
              onClick={handleSubmit}
              loading={loading}
              disabled={loading}
            >
              {t('resetPassword.form.reset')}
            </Button>
          </div>
        </div>
      </div>
    </FormProvider>
  );
};
export default ResetPasswordForm;
